<template>
	<!-- Main Sections -->
	<main class="main-wrapper bg-lightest-gray">

		<!-- Title Banner Start -->
		<section class="title-banner">
			<div class="container-fluid">
				<div class="banner-wrapper">
					<img src="/assets/media/banner/left-image.png" alt="" class="banner-image1">
					<h1 class="dark-black fw-600">О магазине</h1>
					<img src="/assets/media/banner/right-image.png" alt="" class="banner-image2">
				</div>
			</div>
		</section>
		<!-- Title Banner End -->

		<!-- About Section Start -->
		<section class="about-section py-40">
			<div class="container-fluid">
				<div class="about-wrapper bg-white">
					<div class="about-block mb-24">
						<div class="row align-items-center row-gap-4">
							<div class="col-xl-6 col-lg-7 order-sm-1 order-2">
								<div class="about-content">
									<h3 class="mb-24">Путешествие по нашей истории</h3>
									<p class="light-gray mb-12">
										Добро пожаловать в <span class="dark-black fw-500">InterMagTech - Магазин электронной техники, </span> Ваш источник номер один для всех электронных аксессуаров. Мы стремимся предоставить вам самые лучшие зарядные устройства, наушники, кабели и многое другое, уделяя особое внимание качеству, доступности и удовлетворенности клиентов.
									</p>
									<p class="light-gray">
										Основана в 2021 году основателем <span class="dark-black fw-500">Герман Кириллом</span>. InterMagTech прошел долгий путь с момента своего основания в Астане, РК. Когда Герман Кирилл только начинал, его страсть к технологиям и электронике подтолкнула его к открытию собственного бизнеса. Его цель была проста: предлагать высококачественную продукцию, которая была бы не только надежной, но и доступной.
									</p>
	
								</div>
							</div>
							<div class="col-xl-6 col-lg-5 order-sm-2 order-1">
								<div class="about-image">
									<img src="/assets/media/about/about-1.png" alt="" class="br-20">
								</div>
							</div>
						</div>
					</div>
					<div class="about-block mb-24">
						<div class="row align-items-center row-gap-4">
							<div class="col-xl-6 col-lg-5 ">
								<div class="about-image">
									<img src="/assets/media/about/about-2.png" alt="" class="br-20">
								</div>
							</div>
							<div class="col-xl-6 col-lg-7">
								<div class="about-content">
									<h3 class="mb-24">Наша миссия и ценности</h3>
									<p class="light-gray mb-24">
										В <span class="dark-black fw-500">InterMagTech - Магазине электронной техники, </span> Ваш источник номер один для всех электронных аксессуаров. Мы стремимся предоставить вам самые лучшие зарядные устройства, наушники, кабели и многое другое, уделяя особое внимание качеству, доступности и удовлетворенности клиентов.
									</p>
									<ul>
										<li class="fw-500 mb-8">Качественная продукция</li>
										<li class="fw-500 mb-8">Доступность</li>
										<li class="fw-500 mb-8">Превосходное обслуживание клиентов</li>
										<li class="fw-500 mb-8">Инновации</li>
										<li class="fw-500">Устойчивость</li>
									</ul>
	
								</div>
							</div>
						</div>
					</div>
					<div class="about-block">
						<div class="row align-items-center row-gap-4">
							<div class="col-xl-6 col-lg-7 order-sm-1 order-2">
								<div class="about-content">
									<h3 class="mb-24">Наша миссия и ценности</h3>
									<p class="light-gray mb-24">
										Мы предлагаем широкий ассортимент электронных аксессуаров, разработанных для удовлетворения всех ваших потребностей. Если вы ищете новейшие беспроводные наушники, кабели для быстрой зарядки, прочные чехлы или инновационные гаджеты, у нас есть что-то для каждого.
									</p>
									<ul>
										<li class="fw-500 mb-8">Зарядные устройства</li>
										<li class="fw-500 mb-8">Наушники и вкладыши</li>
										<li class="fw-500 mb-8">Кабели и разъемы</li>
										<li class="fw-500 mb-8">Чехлы и обложки</li>
										<li class="fw-500">Гаджеты для умного дома</li>
									</ul>
	
								</div>
							</div>
							<div class="col-xl-6 col-lg-5 order-sm-2 order-1">
								<div class="about-image">
									<img src="/assets/media/about/about-3.png" alt="" class="br-20">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- About Section End -->

		<!-- Why Choose Us -->
		<section class="whyChoose-us py-40">
			<div class="container-fluid">
				<div class="title-row text-center mb-16">
					<h5>Почему выбирают нас?</h5>
				</div>
				<div class="row row-gap-3">
					<div class="col-xl-3 col-lg-6 col-sm-6">
						<div class="our-block bg-white br-10 text-center">
							<div class="icon-block m-auto">
								<img src="/assets/media/icons/quality.png" alt="">
							</div>
							<h6 class="mt-24 fw-600">Гарантия качества</h6>
						</div>
					</div>
					<div class="col-xl-3 col-lg-6 col-sm-6">
						<div class="our-block bg-white br-10 text-center">
							<div class="icon-block m-auto">
								<img src="/assets/media/icons/customer.png" alt="">
							</div>
							<h6 class="mt-24 fw-600">Клиентоориентированность</h6>
						</div>
					</div>
					<div class="col-xl-3 col-lg-6 col-sm-6">
						<div class="our-block bg-white br-10 text-center">
							<div class="icon-block m-auto">
								<img src="/assets/media/icons/wishlist-icon.png" alt="">
							</div>
							<h6 class="mt-24 fw-600">Безопасные покупки</h6>
						</div>
					</div>
					<div class="col-xl-3 col-lg-6 col-sm-6">
						<div class="our-block bg-white br-10 text-center">
							<div class="icon-block m-auto">
								<img src="/assets/media/icons/cheque.png" alt="">
							</div>
							<h6 class="mt-24 fw-600">Доступные цены</h6>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- Why Choose Us -->
		
		<!-- FAQ's Section Start -->
		<div class="faq py-40">
			<div class="container-fluid">
				<div class="title-row mb-16 text-center">
					<h5>Часто задаваемые вопросы</h5>
				</div>
				<div class="row row-gap-3">
					<div class="col-xl-6 col-lg-12">
						<div id="accordionExample">
							<div class="faq-block">
								<a href="#" class="accordion-button" data-bs-toggle="collapse" data-bs-target="#faq1" aria-expanded="true" aria-controls="faq1">Какова политика возврата вашей продукции?</a>
								<div id="faq1" class="accordion-collapse collapse show" aria-labelledby="faq1" data-bs-parent="#accordionExample">
									<p class="light-gray">
										Мы предлагаем 30-дневную политику возврата на все наши продукты. Если вы не удовлетворены своей покупкой, вы можете вернуть товар в течение 30 дней с момента доставки для полного возврата денег или обмена. Пожалуйста, убедитесь, что продукт находится в своем первоначальном состоянии и упаковке.
									</p>
								</div>
							</div>
							<div class="faq-block">
								<a href="#" class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq2" aria-expanded="true" aria-controls="faq2">Как я могу отслеживать свой заказ?</a>
								<div id="faq2" class="accordion-collapse collapse " aria-labelledby="faq2" data-bs-parent="#accordionExample">
									<p class="light-gray">
										Мы предлагаем 30-дневную политику возврата на все наши продукты. Если вы не удовлетворены своей покупкой, вы можете вернуть товар в течение 30 дней с момента доставки для полного возврата денег или обмена. Пожалуйста, убедитесь, что продукт находится в своем первоначальном состоянии и упаковке.
									</p>
								</div>
							</div>
							<div class="faq-block m-0">
								<a href="#" class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq3" aria-expanded="true" aria-controls="faq3">Как я могу связаться со службой поддержки клиентов?</a>
								<div id="faq3" class="accordion-collapse collapse " aria-labelledby="faq3" data-bs-parent="#accordionExample">
									<p class="light-gray">
										Мы предлагаем 30-дневную политику возврата на все наши продукты. Если вы не удовлетворены своей покупкой, вы можете вернуть товар в течение 30 дней с момента доставки для полного возврата денег или обмена. Пожалуйста, убедитесь, что продукт находится в своем первоначальном состоянии и упаковке.
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-6 col-lg-12">
						<div id="accordionExample_2">
							<div class="faq-block">
								<a href="#" class="accordion-button" data-bs-toggle="collapse" data-bs-target="#faq5" aria-expanded="true" aria-controls="faq5">Осуществляете ли вы международную доставку?</a>
								<div id="faq5" class="accordion-collapse collapse show" aria-labelledby="faq5" data-bs-parent="#accordionExample_2">
									<p class="light-gray">
										Ответ: Да, мы предлагаем международную доставку в большинство стран. Стоимость доставки и время доставки зависят от пункта назначения. Вы можете просмотреть варианты доставки и стоимость во время оформления заказа.
									</p>
								</div>
							</div>
							<div class="faq-block">
								<a href="#" class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq6" aria-expanded="true" aria-controls="faq6">Какие способы оплаты вы принимаете?</a>
								<div id="faq6" class="accordion-collapse collapse " aria-labelledby="faq6" data-bs-parent="#accordionExample_2">
									<p class="light-gray">
										Мы предлагаем 30-дневную политику возврата на все наши продукты. Если вы не удовлетворены своей покупкой, вы можете вернуть товар в течение 30 дней с момента доставки для полного возврата денег или обмена. Пожалуйста, убедитесь, что продукт находится в своем первоначальном состоянии и упаковке.
									</p>
								</div>
							</div>
							<div class="faq-block m-0">
								<a href="#" class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq7" aria-expanded="true" aria-controls="faq7">Как применить код скидки к моему заказу?</a>
								<div id="faq7" class="accordion-collapse collapse " aria-labelledby="faq7" data-bs-parent="#accordionExample_2">
									<p class="light-gray">
										Мы предлагаем 30-дневную политику возврата на все наши продукты. Если вы не удовлетворены своей покупкой, вы можете вернуть товар в течение 30 дней с момента доставки для полного возврата денег или обмена. Пожалуйста, убедитесь, что продукт находится в своем первоначальном состоянии и упаковке.
									</p>
								</div>
							</div>
						</div>
					</div>
					</div>
			</div>
		</div>
		<!-- FAQ's Section End -->

		<benefits :footer-class="['bg-white', 'mt-40']" />
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Benefits from '@/components/Benefits';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech'});
	},
	data: () => ({
		
	}),
	methods: {},
	mounted(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		Benefits
	},
};
</script>